import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http: www.w3.org 2000 svg",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 320 320"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M310 10H10v300Z",
  class: "path1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 310V160h150v150L10 160",
  class: "path2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M310 10v150H160V10L10 160",
  class: "path3"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 310h300V10H10l300 300",
  class: "path4"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }